<template>
  <v-card class="elevation-12">
    <GlobalUsersDataTable
        :loading="loading"
        :users="users"
        :total="total"
        @update="onUpdate"
    />
  </v-card>
</template>

<script>
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP, LAYOUT_TITLE_CHANGED} from "@/store/modules/layout/actions";
import _ from "underscore";
import Mappers from "@/mappers";
import GlobalUsersDataTable from "@/components/user/GlobalUsersDataTable.vue";
import GlobalUserService from "@/services/global.user.service";

export default {
  name: "GlobalUsersPage",
  components: {
    GlobalUsersDataTable,
  },
  data() {
    return {
      users: [],
      total: 0,
      loading: false,
    }
  },
  methods: {
    reloadUsers(options, filters) {
      this.loading = true
      this.$store.dispatch(LAYOUT_LOADING_START)

      const {unitId, user} = filters;
      const {page, itemsPerPage} = options;

      const skip = (page - 1) * itemsPerPage;

      GlobalUserService.getUsers({
        skip: skip,
        limit: itemsPerPage,
        id: unitId,
        user: user
      })
          .then(response => {
            this.users = _.map(response.data.Records, o => {
              return Mappers.mapGlobalUser(o)
            })

            this.total = response.data.Total
          })
          .finally(() => {
            this.loading = false
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
    onUpdate(options, filters) {
      this.reloadUsers(options, filters)
    }
  },
  created() {
    this.$store.dispatch(LAYOUT_TITLE_CHANGED, this.$t('globalUsersPage.pageTitle'))
  }
}
</script>